module.exports = __webpack_public_path__ + "img/win.f25c62a7.svg";